export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 50;
export const LOGO_HEIGHT_MOBILE = 40;
export const LOGO_WIDTH_MOBILE = 40;
export const maxCardWidthMobile = "300px";
export const bannerPagePhotoHeight_SM = "30vh";
export const bannerPagePhotoHeight_LG = "40vh";
